import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from "@/plugins/vuetify";
import userMixin from "@/mixins/user.mixin";
import navigation from "@/static/data/navigation";
import alertMixin from "@/mixins/alert.mixin";
import reusedCodeMixin from "@/mixins/reusedCode.mixin";
import staticModal from "@/mixins/modals/staticModal";

createApp(App)
    .use(store)
    .use(router)
    .use(vuetify)
    .mixin(staticModal)
    .mixin(reusedCodeMixin)
    .mixin(navigation)
    .mixin(alertMixin)
    .mixin(userMixin)
    .mount('#app')
